import { createEpicMiddleware, combineEpics } from "redux-observable";

import amplitudeEpics from "../modules/amplitude/epics";
import audioEpics from "../modules/audio/epics";
import libraryEpics from "../modules/library/epics";

const epicMiddleware = createEpicMiddleware();

export function runEpics() {
  const epics = combineEpics(
    amplitudeEpics,
    audioEpics,
    libraryEpics,
  );

  epicMiddleware.run(epics);
}

export default epicMiddleware;
